<template>
	<div id="coordinates" v-if="coordinates">
		<table>
			<tr>
				<td><label for="coordinates_address">address:</label></td>
				<td>
					<input
						name="coordinates_address"
						id="coordinates_address"
						type="text"
						v-model="coordinates.address"
					/>
				</td>
			</tr>
			<tr>
				<td><label for="coordinates_x">x:</label></td>
				<td>
					<input name="coordinates_x" id="coordinates_x" type="text" v-model="coordinates.x" />
				</td>
			</tr>
			<tr>
				<td><label for="coordinates_y">y:</label></td>
				<td>
					<input name="coordinates_y" id="coordinates_y" type="text" v-model="coordinates.y" />
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
	import { mapMutations, mapState } from "vuex";

	export default {
		methods: {
			...mapMutations(["setCoordinates"])
		},
		computed: {
			...mapState(["userLogged", "userLoggedInfo", "coordinates"])
		},
		created() {
			// User is logged in and has saved coordinates -> populate state with saved coordinates
			if (this.userLogged && this.userLoggedInfo && this.userLoggedInfo.coordinates) {
				this.setCoordinates({ ...this.userLoggedInfo.coordinates });
			} else {
				// Else -> populate coordinates with empty values
				// No need... this is the initial value in state.js
				// this.setCoordinates({ address: null, x: null, y: null });
			}
		}
	};
</script>

<style lang="sass" scoped>
	#coordinates
		display: none
		padding: 4rem
</style>
